import { render, staticRenderFns } from "./SbpPaymentModal.vue?vue&type=template&id=d6a3057e"
import script from "./SbpPaymentModal.vue?vue&type=script&lang=js"
export * from "./SbpPaymentModal.vue?vue&type=script&lang=js"
import style0 from "./SbpPaymentModal.vue?vue&type=style&index=0&id=d6a3057e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports